import React, { useCallback } from 'react';
import { FileError, useDropzone } from 'react-dropzone';
import { AppButton } from '@common-fe/common-fe';

import { ACCEPTED_FILE_TYPES, FileImage, MAX_SIZE_OF_FILE } from '@/common/constants';
import prepareFile from '@/components/elements/DropScan/prepareFile';
import useFilesInDocumentStore from '@/components/elements/DropScan/useFilesInDocument.store';
import useOnDrop from '@/components/elements/DropScan/useOnDrop';

interface Props {
  onUpload?: () => void;
  onFileUploadError?: (error?: FileError) => void;
  style?: React.CSSProperties;
  storeKey?: string;
}

const UploadButton: React.FC<Props> = ({ onUpload, onFileUploadError, style, storeKey }) => {
  const { handleSetValues } = useFilesInDocumentStore(storeKey);

  const onFilesAdded = useCallback(
    (acceptedFiles: FileImage[]) => {
      if (acceptedFiles?.length) {
        handleSetValues({ files: acceptedFiles.map(prepareFile) });
        onUpload?.();
      }
    },
    [handleSetValues, onUpload]
  );

  const { onDrop } = useOnDrop({ onFilesAdded, onFileUploadError, disableFilesUpload: true, storeKey });
  const { getInputProps, open } = useDropzone({
    accept: ACCEPTED_FILE_TYPES,
    maxSize: MAX_SIZE_OF_FILE,
    onDrop,
    noDrag: true,
    noClick: true,
    multiple: false,
    maxFiles: 1,
  });

  return (
    <>
      <AppButton onClick={open} buttonType="primary" style={{ minWidth: '120px', ...style }}>
        Upload
      </AppButton>

      <input {...getInputProps()} />
    </>
  );
};

export default UploadButton;
